import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { CaptionManComponent } from './caption-man/caption-man.component';

import { ReactiveFormsModule } from '@angular/forms';
import { UnescapePipe } from './unescape.pipe';
import { SettingsComponent } from './settings/settings.component';
import { MinsecPipe } from './minsec.pipe';
import { SharesComponent } from './shares/shares.component';
import { RouterModule, Routes } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

const routes: Routes = [];
@NgModule({
  declarations: [
    AppComponent,
    CaptionManComponent,
    UnescapePipe,
    SettingsComponent,
    MinsecPipe,
    SharesComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes),
    NgSelectModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
